<template>
	<section class="framework" :class="slug" v-if="data">
        <header class="framework__header">
            <strong class="framework__name">{{name}}</strong>
        </header>
        <div class="framework__data">
            <div class="framework__data-info">
                <div class="framework__period">                
                    <span class="framework__period-text">{{info.label | moment('D MMMM yyyy')}}</span>
                </div>
                
                <strong class="framework__downloads" v-if="name == 'Pendapatan'">{{info.value | currency}}</strong>
                <strong class="framework__downloads" v-else-if="name == 'Lead Time (Pengiriman)'">{{info.value}} Day</strong>
                <strong class="framework__downloads" v-else>{{info.value}}</strong>
            </div>
            <trend-chart v-if="dataset.data.length > 1" :datasets="[dataset]" :min="0" padding="5 5 0" :interactive="true" @mouse-move="onMouseMove"></trend-chart>                
        </div>
    </section>
</template>
<script>

export default {
	name: 'Chart',
	props: {
        data: {
            type: Array,
            required: true
        },
        slug: {
            type: String,
            required: true
        },
        type: null
    },
    data() {
        return {
            currentInfo: null
        };
    },
    computed: {
        name() {
            return `${this.slug[0].toUpperCase() + this.slug.slice(1)}`;
        },
        weeklyDownloads() {
            return this.numberWithSpaces(this.data.reduce((a, c) => a + parseInt(c.value), 0));
        },
        dataset() {
            return {
                data: this.data,
                showPoints: true,
                fill: true,
                className: `curve-${this.slug}`                
            };            
        },
        info() {
            return {
                label: this.currentInfo ? this.currentInfo.label : this.type,
                value: this.currentInfo ? this.currentInfo.value : this.weeklyDownloads
            };
        }
    },
    methods: {
        numberWithSpaces(n) {
            return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        onMouseMove(params) {
            if (!params) {
                this.currentInfo = null;
                return;
            }
            this.currentInfo = {
                label: params.data[0].day,
                value: this.numberWithSpaces(params.data[0].value)
            };
        }
    }
}
</script>